import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import { CommentViewModel, CommentType } from '@models/Comment';
import { ModalProps } from '@common/components/modal/_components/modal.component';
import { Comment } from 'src/comments/_components/comment/comment.container';
import { OptionsViewModel } from '@models/common.models';
import { dateParser } from '@common/dateParser';

export interface ActioningListComponentProperties {
  readonly loading?: boolean;
  readonly pageCount: number;
  readonly actioningList: Array<CommentViewModel>;
  readonly usersToAction: Array<OptionsViewModel>;
  readonly pageNumber?: number;
  readonly pageSize?: number;
  readonly totalResults?: number;
  readonly getActioningList: (pageNumber: number, pageSize: number, orderDirection: string) => void;
  readonly gotoComment: (id: number) => void;
  readonly completeComment: (oldComment: CommentViewModel, pageNumber: number) => void;
  readonly showCompleteActionModal: (comment: CommentViewModel) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly toggleDialog: (comment: string) => void;
  readonly saveComment: (comment: CommentViewModel, usersToAction: OptionsViewModel[]) => void;
}

export class ActioningListComponent extends React.Component<ActioningListComponentProperties> {
  private isInitialized = false;

  componentDidMount() {
    this.props.getActioningList(1, 10, 'asc');
  }

  completeAction = (comment: CommentViewModel) => {
    this.props.toggleModal({
      title: 'Complete Action Item',
      component: Comment,
      childProps: {
        oldCommentText: comment.comment,
        entityId: comment.entityId,
        commentType: comment.commentType,
        isActionComplete: true,
        hideSave: true
      },
      saveCallback: () => this.props.completeComment(comment, this.props.pageNumber || 1)
    });
  };

  render() {
    const columns: Column[] = [
      {
        accessor: (a: CommentViewModel) => CommentType[a.commentType],
        id: 'type',
        Header: 'Type',
        sortable: false,
        width: 100
      },
      {
        accessor: (d: CommentViewModel) => (d ? <>{this.renderCommentLink(d)}</> : 'N/A'),
        id: 'entityId',
        Header: 'Record #',
        sortable: false,
        width: 100
      },
      {
        accessor: 'comment',
        Header: 'Comment',
        sortable: false
      },
      {
        accessor: (a: CommentViewModel) => (a.employee ? a.employee.value : ''),
        id: 'employee',
        Header: 'Actioned By',
        sortable: false,
        width: 140
      },
      {
        accessor: (d: CommentViewModel) => (d ? <>{dateParser.parse(d.addedDate).format('l LT')}</> : 'N/A'),
        id: 'addedDate',
        Header: 'Date',
        sortable: true,
        width: 100,
        defaultSortDesc: true
      },
      {
        accessor: (d: CommentViewModel) =>
          d ? (
            <a className={this.props.loading ? 'disabled' : 'active'} onClick={() => this.completeAction(d)}>
              <i className="fas fa-fw fa-check pointer" />
            </a>
          ) : (
            'N/A'
          ),
        id: 'commentId',
        Header: 'Actions',
        sortable: false,
        width: 100
      }
    ];
    return (
      <div className="pt-10 light-gray-bc">
        <h2>My Action Items</h2>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.props.actioningList || []}
          defaultPageSize={10}
          loading={this.props.loading}
          manual={true}
          onFetchData={this.handleFetchData}
          pages={this.props.pageCount}
        />
      </div>
    );
  }

  // private handleCommentCompleteClick(row: CommentViewModel) {
  //     this.props.showCompleteActionModal(row);
  //     // this.props.completeComment(row.commentId, row.type);
  // }

  private renderCommentLink(row: CommentViewModel) {
    var location: string = '';
    switch (row.commentType) {
      case CommentType.Swo:
        location = RouteDefinitions.serviceworkorder.Details;
        break;
      case CommentType.Contract:
        location = RouteDefinitions.contract.Details;
        break;
      case CommentType.Customer:
        location = RouteDefinitions.customer.Details;
        break;
      case CommentType.Vendor:
        location = RouteDefinitions.vendor.Details;
        break;
      default:
        location = RouteDefinitions.dashboard;
        break;
    }
    return (
      <Link to={getRoute(location, { id: +row.entityId! })} onClick={() => this.handleCommentClick(row.comment)}>
        {row.entityDisplayName}
      </Link>
    );
  }

  private handleCommentClick = (comment: string) => {
    this.props.toggleDialog(comment);
  };

  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'asc';

    if (this.isInitialized) {
      this.props.getActioningList(state.page + 1, state.pageSize, orderDirection);
    }

    this.isInitialized = true;
  };
}



// WEBPACK FOOTER //
// ./src/actioning/_components/actioning-list/actioning-list.component.tsx